import React from 'react';
import { bonuses } from '../data/kit';
import { pricing } from '../data/pricing';
export function BonusesSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-21" data-mp="gwx4d05qj1co">
      <div className="max-w-3xl mx-auto" data-id="element-22" data-mp="vsmlajw2coaj">
        <div className="text-center mb-12" data-id="element-23" data-mp="vtnvkm5996r7">
          <h2 className="text-3xl md:text-4xl font-black text-brand-text mb-4" data-id="element-24" data-mp="qtt68n14op89">
            5 Bonos Exclusivos
          </h2>
          <p className="text-brand-gray" data-id="element-25" data-mp="14t2p5ugpxxfx">
            Valorados en{' '}
            <span className="font-bold text-brand-terracotta line-through" data-id="element-26" data-mp="zuhlfl29cvmq">
              {pricing.bonusesValue}
            </span>{' '}
            — los llevás <strong className="text-brand-text" data-id="element-27" data-mp="1ei2nrcrb6qtl">GRATIS</strong>
          </p>
        </div>

        <ul className="space-y-4" data-id="element-28" data-mp="19lc98tv5k3aa">
          {bonuses.map((bonus, i) => <li key={bonus.title} className="bg-white rounded-2xl p-4 md:p-5 flex items-center gap-4 md:gap-6 shadow-sm border border-brand-creamDark/50" data-id="element-29" data-mp="1njkb9g71pusb" data-mpi={i}>
              <span className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-green text-white flex items-center justify-center font-bold shrink-0 text-sm md:text-base" data-id="element-30" data-mp="3pqtv8oxv65gy">
                {i + 1}
              </span>
              <img src={bonus.image} alt={bonus.alt} loading="lazy" className="w-20 h-20 md:w-24 md:h-24 rounded-xl object-cover shrink-0 border border-brand-creamDark/60" data-id="element-31" data-mp="2lcmrzh8r7ou" />
              <div className="flex-1" data-id="element-32" data-mp="chpdqplej7fw">
                <h3 className="font-bold text-brand-text text-sm md:text-base mb-1" data-id="element-33" data-mp="gkvmq4zwfcq2">
                  {bonus.title}
                </h3>
                <div className="flex items-center gap-2 text-xs md:text-sm" data-id="element-34" data-mp="lcn9s5juj0bg">
                  <span className="text-brand-terracotta line-through font-medium" data-id="element-35" data-mp="qa5che79sjb0">
                    {pricing.bonusUnitValue}
                  </span>
                  <span className="text-brand-green font-bold" data-id="element-36" data-mp="109e3by6u9ht5">GRATIS</span>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}